module.exports = __webpack_public_path__ + "static/media/card-image-df-distribuidora.aeda811f.jpg";